/*
 * @description: element-ui 按需引入
 * @Author: Jay
 * @Date: 2021-09-23 09:19:41
 * @LastEditors: Jay
 * @LastEditTime: 2026-08-06 15:57:41
 */
import {
  Image,
  Button,
  Input,
  Loading,
  Tabs,
  TabPane,
  Form,
  FormItem,
  Message,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  RadioButton,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Popover,
  Dialog,
  Pagination,
  DatePicker,
  Select,
  Option,
  Table,
  TableColumn,
  Empty,
  Upload,
  Link,
  Steps,
  Step,
  Switch,
  Carousel,
  CarouselItem,
  Tooltip,
  MessageBox,
  Tag,
  Breadcrumb,
  BreadcrumbItem,
  Cascader,
  Dropdown,
  DropdownMenu,
  DropdownItem
} from "element-ui";
//注意：样式文件需要单独引入
import "element-ui/lib/theme-chalk/index.css";
const element = {
  install: function (Vue) {
    //图片
    Vue.use(Image);
    //按钮
    Vue.use(Button);
    //输入框
    Vue.use(Input);
    //加载
    Vue.use(Loading.directive);
    Vue.prototype.$loading = Loading.service;
    // 标签页
    Vue.use(Tabs);
    Vue.use(TabPane);
    // 表单
    Vue.use(Form);
    Vue.use(FormItem);
    // 消息提示
    Vue.prototype.$message = Message;
    // 多选框
    Vue.use(Checkbox)
    Vue.use(CheckboxGroup)
    // 单选
    Vue.use(Radio)
    Vue.use(RadioGroup)
    Vue.use(RadioButton)
    // 导航菜单
    Vue.use(Menu)
    Vue.use(Submenu)
    Vue.use(MenuItem)
    Vue.use(MenuItemGroup)
    // 弹出框
    Vue.use(Popover)
    //对话框
    Vue.use(Dialog)
    // 分页
    Vue.use(Pagination)
    // 日期选择器
    Vue.use(DatePicker)
    // 选择器
    Vue.use(Select)
    Vue.use(Option)
    //表格
    Vue.use(Table);
    Vue.use(TableColumn);
    // 空状态
    Vue.use(Empty)
    // 上传
    Vue.use(Upload)
    // 文字链接
    Vue.use(Link)
    // 步骤条
    Vue.use(Steps)
    Vue.use(Step)
    // 开关
    Vue.use(Switch)
    // 走马灯
    Vue.use(Carousel)
    Vue.use(CarouselItem)
    // 标签页
    Vue.use(Tabs)
    Vue.use(TabPane)
    // 文字提示
    Vue.use(Tooltip)
    // 标签
    Vue.use(Tag)
    // 面包屑
    Vue.use(Breadcrumb)
    Vue.use(BreadcrumbItem)
    // 级联选择器
    Vue.use(Cascader)
    // 下拉菜单
    Vue.use(Dropdown)
    Vue.use(DropdownMenu)
    Vue.use(DropdownItem)

    // MessageBox 弹框
    Vue.prototype.$msgbox = MessageBox;
    Vue.prototype.$alert = MessageBox.alert;
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.prototype.$prompt = MessageBox.prompt;
  },
};
export default element;
